/**
 * @generated SignedSource<<b1316c250a16e820bf3707e98029e055>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RateCardDropdown_rateCards$data = ReadonlyArray<{
  readonly node: {
    readonly id: string;
    readonly name: string | null;
    readonly currency: string | null;
    readonly parentRateCardId: string | null;
    readonly disabled: boolean | null;
  } | null;
  readonly " $fragmentType": "RateCardDropdown_rateCards";
}>;
export type RateCardDropdown_rateCards$key = ReadonlyArray<{
  readonly " $data"?: RateCardDropdown_rateCards$data;
  readonly " $fragmentSpreads": FragmentRefs<"RateCardDropdown_rateCards">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "RateCardDropdown_rateCards",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RateCard",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "parentRateCardId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "disabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RateCardTypeEdge",
  "abstractKey": null
};

(node as any).hash = "67be2dade080fba19ad9e31ecaebca9e";

export default node;
